export const areaToTitle = (
  areaId: number | undefined,
  areas: CustomerSetting['areas']
): string | undefined => {
  const area = areas.find((area) => area.areaId === areaId);
  if (area) {
    return area.areaName;
  }
  return undefined;
};
